import React, { FC } from 'react'
import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { createResource, useResource } from '@/lib/i18n'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { Animation, Reveal } from 'react-genie'

const resource = createResource({
  id: {
    areaTitle: 'Area Layanan Kredit Pintar',
    sumaterTitle: 'SUMATRA',
    sumaterDesc:
      'Medan, Palembang, Bandar Lampung, Batam, Pekanbaru, Padang, Jambi, Bengkulu, Banda Aceh, dan berbagai kota lainnya di wilayah Sumatra',
    kalimantanTitle: 'KALIMANTAN',
    kalimantanDesc: 'Pontianak, Palangkaraya, Banjarmasin, Samarinda, dan berbagai kota lainnya di wilayah Kalimantan',
    jawabaliTitle: 'JAWA & BALI',
    jawabaliDesc:
      'DKI Jakarta, Serang, Bandung, Surabaya, Semarang, Denpasar, dan berbagai kota lainnya di wiayah Jawa dan Bali',
    sulawesiTitle: 'SULAWESI',
    sulawesiDesc: 'Makassar, Manado, Kendari, Palu, Gorontalo, dan berbagai kota lainnya di wilayah Sulawesi',
    papuaTitle: 'PAPUA',
    papuaDesc: 'Jayapura, Sorong, Merauke, Manokwari, Timika, dan berbagai kota lainnya di wilayah Papua',
  },
  en: {
    areaTitle: 'Kredit Pintar Service Area',
    sumaterTitle: 'SUMATRA',
    sumaterDesc:
      'Medan, Palembang, Bandar Lampung, Batam, Pekanbaru, Padang, Jambi, Bengkulu, Banda Aceh, dan berbagai kota lainnya di wilayah Sumatra',
    kalimantanTitle: 'KALIMANTAN',
    kalimantanDesc: 'Pontianak, Palangkaraya, Banjarmasin, Samarinda, dan berbagai kota lainnya di wilayah Kalimantan',
    jawabaliTitle: 'JAWA & BALI',
    jawabaliDesc:
      'DKI Jakarta, Serang, Bandung, Surabaya, Semarang, Denpasar, dan berbagai kota lainnya di wiayah Jawa dan Bali',
    sulawesiTitle: 'SULAWESI',
    sulawesiDesc: 'Makassar, Manado, Kendari, Palu, Gorontalo, dan berbagai kota lainnya di wilayah Sulawesi',
    papuaTitle: 'PAPUA',
    papuaDesc: 'Jayapura, Sorong, Merauke, Manokwari, Timika, dan berbagai kota lainnya di wilayah Papua',
  },
})

interface IArea {
  imagePath: string
  title: string
  desc: string
}

const Area = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const areaList: IArea[] = [
    {
      imagePath: '/images/home/area-sumater.png',
      title: 'sumaterTitle',
      desc: 'sumaterDesc',
    },
    {
      imagePath: '/images/home/area-kalimantan.png',
      title: 'kalimantanTitle',
      desc: 'kalimantanDesc',
    },
    {
      imagePath: '/images/home/area-jawabali.png',
      title: 'jawabaliTitle',
      desc: 'jawabaliDesc',
    },
    {
      imagePath: '/images/home/area-sulawesi.png',
      title: 'sulawesiTitle',
      desc: 'sulawesiDesc',
    },
    {
      imagePath: '/images/home/area-papua.png',
      title: 'papuaTitle',
      desc: 'papuaDesc',
    },
  ]

  return (
    <AreaStyles>
      {width >= 1000 ? (
        <div className="content-pc">
          <h2 className="title">{t('areaTitle')}</h2>
          <div className="items">
            {areaList.map((item: IArea, index) => (
              <Reveal key={item.imagePath} delay={200 + index * 150} animation={Animation.FadeIn}>
                <ItemStyles {...item}>
                  <div className="item">
                    <div className="item-title">{t(item.title as any)}</div>
                    <div className="item-desc">{t(item.desc as any)}</div>
                  </div>
                </ItemStyles>
              </Reveal>
            ))}
          </div>
        </div>
      ) : (
        <div className="content-mobile">
          <h2 className="title">{t('areaTitle')}</h2>
          <Swiper className="swiper" loop={true} pagination={{ clickable: true }}>
            {areaList.map((item: IArea) => (
              <SwiperSlide key={item.imagePath}>
                <ItemStyles {...item}>
                  <div className="item">
                    <div className="item-title">{t(item.title as any)}</div>
                    <div className="item-desc">{t(item.desc as any)}</div>
                  </div>
                </ItemStyles>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </AreaStyles>
  )
}

export default Area

const ItemStyles = styled.div<IArea>`
  @media only screen and (min-width: 1000px) {
    .item {
      display: flex;
      flex-direction: column;
      width: 216px;
      margin-right: 15px;
      height: 264px;
      &:last-child {
        margin-left: 0px;
      }
      background-image: url(${(props) => `${props.imagePath}`});
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: center;
    }
  }
  @media only screen and (max-width: 1000px) {
    .item {
      display: flex;
      flex-direction: column;
      width: 216px;
      margin: 0 auto;
      height: 264px;
      background-image: url(${(props) => `${props.imagePath}`});
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: center;
    }
  }

  .item-title {
    padding-top: 144px;
    font-family: Roboto-Bold, Roboto;
    font-size: 19px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.87);
    line-height: 23px;
  }
  .item-desc {
    font-size: 11px;
    font-family: Roboto-Regular, Roboto;
    color: #212121;
    line-height: 13px;
    padding: 4px 18px 0 11px;
  }
`

const AreaStyles = styled.div`
  @media only screen and (min-width: 1000px) {
    .content-pc {
      text-align: center;
      margin: 0 auto;
      max-width: 1440px;
      margin-top: 104px;
      height: 720px;
      background-image: url('/images/home/area-pc-bg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .title {
        display: inline-block;
        font-family: Roboto-Medium, Roboto;
        font-size: 36px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 48px;
        margin-top: 147px;
        margin-bottom: 102px;
      }
      .items {
        display: flex;
        justify-content: center;
        max-width: 1440px;
      }
    }
  }
  @media only screen and (max-width: 1000px) {
    .content-mobile {
      text-align: center;
      margin: 0 auto;
      height: 592px;
      background-image: url('/images/home/area-mobile-bg.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .title {
        display: inline-block;
        font-size: 24px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 28px;
        margin-top: 73px;
        margin-bottom: 55px;
      }
      .swiper {
        height: 336px;
      }
    }
  }
`
